import React, { useEffect, useState } from 'react';
import fetchListingsFromLambda from './Components/fetchListingsFromLambda';
import ListingInfo from './Components/ListingInfo';

const App = () => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState(null);

  function sendHeightToParent() {
    const contentHeight = document.querySelector('.listingsContainer').offsetHeight;
    const padding = 50; // padding top and bottom
    const scrollbarWidth = 15; // rough width of a scrollbar
    const newHeight = contentHeight + 2 * padding + scrollbarWidth;
    console.log('Sending height to parent', newHeight);
    window.parent.postMessage({ frameHeight: newHeight }, '*');
  }

  useEffect(() => {
    const fetchData = async () => {
      const fetchedListings = await fetchListingsFromLambda();
      if (fetchedListings) {
        setListings(fetchedListings);
        setLoading(false);
        setTimeout(sendHeightToParent, 500); // Adjust this delay as needed
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const spaceType = urlParams.get('filterSpaceType');
    if (spaceType) {
      setFilter(spaceType);
    }
  }, []);

  return (
    <div className="listingsContainer">
      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        (() => {
          const validListings = listings.filter(listing => {
            const spaceTypeObj = listing.UserDefinedFields && listing.UserDefinedFields.length 
              ? listing.UserDefinedFields.find(field => field.Key === "Space Type") 
              : null;
            const spaceType = spaceTypeObj ? spaceTypeObj.Value : 'Not defined';
            return !filter || filter === spaceType;
          });

          if (validListings.length === 0) {
            return (
              <div className="no-availability">
                Unfortunately, we have no availability at the moment. 
                Please sign up for the Waitlist and we will be in touch soon!
                <div><a className="waitlistBtn" href="https://artthausstudios.com/waitlist/" target='new'>Waitlist</a></div>
              </div>
            );
          }

          return validListings.map((listing, index) => (
            <li key={index} className="listingItem">
              <ListingInfo listing={listing} filterSpaceType={filter} />
            </li>
          ));
        })()
      )}
    </div>
  );
};

export default App;
